import { Link } from "react-router-dom";
import { ArrowRight, Droplets, AlertCircle, Search, Flame, Construction, Bath, Wrench, Trash2, Gauge, Droplet, Filter, Beaker, Mountain, ScanSearch } from "lucide-react";

interface ServiceCardProps {
  slug: string;
  title: string;
  shortDesc: string;
  icon: string;
  basePath?: string;
}

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Droplets,
  AlertCircle,
  Search,
  Flame,
  Construction,
  Bath,
  Wrench,
  Trash2,
  Gauge,
  Droplet,
  Filter,
  Beaker,
  Mountain,
  ScanSearch,
};

const ServiceCard = ({ slug, title, shortDesc, icon, basePath = "/services" }: ServiceCardProps) => {
  const IconComponent = iconMap[icon] || Wrench;

  return (
    <Link
      to={`${basePath}/${slug}`}
      className="group block bg-card border border-border rounded-xl p-6 hover:border-primary/50 transition-all duration-300 hover:shadow-copper"
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 gradient-copper rounded-lg flex items-center justify-center">
          <IconComponent className="h-6 w-6 text-primary-foreground" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold text-foreground group-hover:text-primary transition-colors">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">{shortDesc}</p>
        </div>
        <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0" />
      </div>
    </Link>
  );
};

export default ServiceCard;
